define([
    "skylark-utils/skylark"
], function(skylark) {
    return skylark;
});
